/**
 * Type of regulatory report.
 * tag: 1934
 * @readonly
 * @enum {number} (int)
 */
export enum RegulatoryReportType {
  RT = 0,
  PET = 1,
  Snapshot = 2,
  Confirmation = 3,
  RTPET = 4,
  PETConfirmation = 5,
  RTPETConfirmation = 6,
  PostTrade = 7,
  Verification = 8,
  PstTrdEvnt = 9,
  PstTrdEvntRTReportable = 10,
  LMTF = 11,
  DATF = 12,
  VOLO = 13,
  FWAF = 14,
  IDAF = 15,
  VOLW = 16,
  FULF = 17,
  FULA = 18,
  FULV = 19,
  FULJ = 20,
  COAF = 21,
  Order = 22,
  ChildOrder = 23,
  OrderRoute = 24,
  Trade = 25,
  Quote = 26,
  Supplement = 27,
  NewTransaction = 28,
  TransactionCorrection = 29,
  TransactionModification = 30,
  CollateralUpdate = 31,
  MarginUpdate = 32,
  TransactionReportedInError = 33,
  TerminationEarlyTermination = 34,
}
